<nav class="navbar fixed-top aluprof-navbar navbar-expand">

  <div class="container-fluid aluprof-nav-container">

    <!-- =====================================================
         LOGO
         ===================================================== -->
    <a
      class="navbar-brand aluprof-brand"
      [routerLink]="'/Home'">

      <img
        src="../../assets/images/aluprof_biale_logo2.png"
        alt="ALUPROF"
        class="aluprof-logo">

    </a>


    <!-- =====================================================
         HOME
         ===================================================== -->
    <ul class="navbar-nav main-home-nav">

      <li
        class="nav-item"
        [routerLink]="'/Home'">

        <button
          mat-icon-button
          class="nav-icon-button"
          title="Strona główna">

          <mat-icon>
            home
          </mat-icon>

        </button>

      </li>

    </ul>


    <!-- =====================================================
         KONTRAHENT / UŻYTKOWNIK
         ===================================================== -->
    <ul class="navbar-nav contractor-nav">

      <li
        class="nav-item contractor-item"
        role="button"
        (click)="openContractorChooseDialog()">

        <div class="contractor-link">

          <!-- Status -->
          <div class="contractor-status">
            <span class="status-dot"></span>
          </div>

          <!-- Dane -->
          <div class="company-info">

            <div class="company-name">
              {{ Contractor.ContractorName }}
            </div>

            <div class="user-name">
              {{ User.Name }}
            </div>

          </div>

          <!-- Arrow -->
          <mat-icon class="contractor-arrow">
            expand_more
          </mat-icon>

        </div>

      </li>


      <!-- ===================================================
           RABATY
           =================================================== -->

      <li
        *ngIf="this.User.IsTrader"
        class="rabaty"
        id="rabaty"
        [translation]="TranslationEnum.Translation"
        role="button"
        (click)="openRabat(202606)">

        <span class="rabaty-icon">
          %
        </span>

        {{ 'rabaty2026' | translate }}

      </li>

    </ul>


    <!-- =====================================================
         LEWA CZĘŚĆ - SYSTEM / WYCENA / ZAMÓWIENIE
         ===================================================== -->
    <ul class="navbar-nav main-menu">


      <!-- ZAMÓWIENIA -->
      <li
        class="nav-item"
        [routerLinkActive]="'active'"
        [routerLink]="'/Orders'"
        (mouseenter)="systemsTrigger.closeMenu(); valuationTrigger.closeMenu()">

        <a
          class="nav-link"
          role="button"
          id="zamówienia"
          [translation]="TranslationEnum.Translation">

          <mat-icon class="menu-icon">
            receipt_long
          </mat-icon>

          <span>
            {{ 'zamówienia' | translate }}
          </span>

        </a>

      </li>


      <!-- WYCENY -->
      <li 
        class="notvisible nav-item"
        [routerLinkActive]="'active'"
        [routerLink]="'/Valuations'"
        (mouseenter)="systemsTrigger.closeMenu(); valuationTrigger.closeMenu()">

        <a
          class="nav-link"
          role="button"
          id="wyceny"
          [translation]="TranslationEnum.Translation">

          <mat-icon class="menu-icon">
            request_quote
          </mat-icon>

          <span>
            {{ 'wyceny' | translate }}
          </span>

        </a>

      </li>


      <!-- ===================================================
           ZAMÓW
           =================================================== -->
      <li
        ngbDropdown
        class="nav-item widoczne_{{!BlockingB2B}}"
        [routerLinkActive]="'active'"
        (mouseenter)="
          systemsTrigger.openMenu();
          languagesTrigger.closeMenu();
          valuationTrigger.closeMenu()
        ">

        <a
          class="nav-link"
          role="button"
          [matMenuTriggerFor]="systems"
          #systemsTrigger="matMenuTrigger"
          id="zamów"
          [translation]="TranslationEnum.Translation"
          (click)="routeTo('Systems')"
          [routerLink]="'/Systems'">

          <mat-icon class="menu-icon">
            add_shopping_cart
          </mat-icon>

          <span>
            {{ 'zamów' | translate }}
          </span>

          <mat-icon class="menu-arrow">
            expand_more
          </mat-icon>

        </a>


        <mat-menu
          #systems="matMenu"
          [hasBackdrop]="false"
          class="aluprof-menu">

          <div
            class="menu-header">

            <mat-icon>
              add_shopping_cart
            </mat-icon>

            <span>
              {{ 'zamów' | translate }}
            </span>

          </div>

          <div
            (mouseleave)="systemsTrigger.closeMenu()">

            <ng-container
              *ngFor="let system of SystemsList">

              <button
                *ngIf="true || IsTrader"
                mat-menu-item
                (click)="routeToNewOrder2(system)">

                <mat-icon>
                  window
                </mat-icon>

                <span
                  id="{{ 'system_' + system }}"
                  [translation]="TranslationEnum.Translation">

                  {{ 'system_' + system | translate }}

                </span>

              </button>

            </ng-container>

          </div>

        </mat-menu>

      </li>


      <!-- ===================================================
           WYCENIAJ
           =================================================== -->
      <li  
        ngbDropdown
        class="notvisible nav-item widoczne_{{!BlockingB2B}}"
        [routerLinkActive]="'active'"
        (mouseenter)="
          valuationTrigger.openMenu();
          languagesTrigger.closeMenu();
          systemsTrigger.closeMenu()
        ">

        <a
          class="nav-link"
          role="button"
          [matMenuTriggerFor]="valuations"
          #valuationTrigger="matMenuTrigger"
          id="wyceń"
          [translation]="TranslationEnum.Translation"
          (click)="routeTo('ValuationsList')"
          [routerLink]="'/ValuationsList'">

          <mat-icon class="menu-icon">
            calculate
          </mat-icon>

          <span>
            {{ 'wyceń' | translate }}
          </span>

          <mat-icon class="menu-arrow">
            expand_more
          </mat-icon>

        </a>


        <mat-menu
          #valuations="matMenu"
          [hasBackdrop]="false"
          class="aluprof-menu">

          <div class="menu-header">

            <mat-icon>
              calculate
            </mat-icon>

            <span>
              {{ 'wyceń' | translate }}
            </span>

          </div>

          <div
            (mouseleave)="valuationTrigger.closeMenu()">

            <ng-container
              *ngFor="let system of SystemsList">

              <button
                *ngIf="true || IsTrader"
                mat-menu-item
                (click)="routeToValuation(system)">

                <mat-icon>
                  window
                </mat-icon>

                <span
                  id="{{ 'system_' + system }}"
                  [translation]="TranslationEnum.Translation">

                  {{ 'system_' + system | translate }}

                </span>

              </button>

            </ng-container>


            <!-- WYCENA MASOWA -->
            <button
              *ngIf="IsTrader && ShowWarning"
              mat-menu-item
              (click)="routeToMassValuation()">

              <mat-icon>
                view_list
              </mat-icon>

              <span
                id="wycena_masowa"
                [translation]="TranslationEnum.Translation">

                {{ 'wycena_masowa' | translate }}

              </span>

            </button>

          </div>

        </mat-menu>

      </li>

    </ul>


    <!-- =====================================================
         PRAWA CZĘŚĆ
         ===================================================== -->
    <ul class="navbar-nav ml-auto right-menu">


      <!-- POWIADOMIENIA -->
      <li class="nav-item notification-item">

        <app-notification></app-notification>

      </li>


      <!-- TŁUMACZENIE -->
      <li
        class="nav-item"
        title="Tłumaczenie strony">

        <button
          mat-icon-button
          class="nav-icon-button"
          *ngIf="Translate"
          [permission]="PermissionEnum.Translation">

          <mat-icon>
            translate
          </mat-icon>

        </button>

      </li>


      <!-- TECHNOLOGIA -->
      <li
        class="nav-item"
        title="Technologia">

        <button
          mat-icon-button
          class="nav-icon-button technology-button"
          *ngIf="User.IsTrader || ShowWarning"
          [color]="getColor()"
          (click)="changeTechnologyShow()">

          <mat-icon>
            perm_data_setting
          </mat-icon>

        </button>

      </li>


      <!-- USE PARTS -->
      <li
        class="nav-item"
        title="useParts">

        <button
          mat-icon-button
          class="nav-icon-button technology-button"
          *ngIf="User.IsTrader || ShowWarning"
          [color]="getColorParts()"
          (click)="changeuseParts()">

          <mat-icon>
            vibration
          </mat-icon>

        </button>

      </li>


      <!-- ===================================================
           JĘZYK
           =================================================== -->
      <li
        ngbDropdown
        class="nav-item language-item"
        (mouseenter)="
          systemsTrigger.closeMenu();
          languagesTrigger.openMenu();
          valuationTrigger.closeMenu()
        ">

        <a
          class="nav-link language-link"
          role="button"
          [matMenuTriggerFor]="languages"
          #languagesTrigger="matMenuTrigger"
          [id]="this.translateService.currentLang"
          [translation]="TranslationEnum.Translation">

          <span class="flagabox">

            <span
              class="flagawybrana flaga flaga{{this.translateService.currentLang}}">
            </span>

          </span>

          <span>
            {{ this.translateService.currentLang | translate }}
          </span>

          <mat-icon class="menu-arrow">
            expand_more
          </mat-icon>

        </a>


        <mat-menu
          #languages="matMenu"
          [hasBackdrop]="false">

          <div
            class="language-menu"
            (mouseleave)="languagesTrigger.closeMenu()">

            <button
              mat-menu-item
              *ngFor="let lang of this.translateService.langs"
              (click)="changeLanguage(lang)">

              <mat-icon
                class="flaga flaga{{lang}}">
              </mat-icon>

              <span
                [id]="lang"
                [translation]="TranslationEnum.Translation">

                {{ lang | translate }}

              </span>

            </button>

          </div>

        </mat-menu>

      </li>


      <!-- ===================================================
           LOGOUT
           =================================================== -->
      <li
        class="nav-item logout-item"
        (mouseenter)="languagesTrigger.closeMenu()">

        <button
          mat-icon-button
          class="nav-icon-button logout-button"
          title="Wyloguj"
          (click)="logOut()">

          <mat-icon>
            logout
          </mat-icon>

        </button>

      </li>

    </ul>

  </div>

</nav>